import { contractPenaltiesService } from '@/api/contract-penalties.service';
import type { ContractPenaltyType } from '@carvia/ros-client-types';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { BOOKINGS_QUERY_KEY } from './use-bookings';
import { INVOICES_QUERY_KEY } from './use-invoices';
import {
  LEDGER_ENTRIES_QUERY_KEY,
  NETTING_ELIGIBILITY_QUERY_KEY,
  PAYMENT_ALLOCATIONS_QUERY_KEY,
} from './use-ledger';
import { PAYMENTS_QUERY_KEY } from './use-payments';

const DAMAGES_QUERY_KEY = 'damages';
const STORED_PAYMENT_METHODS_QUERY_KEY = 'stored-payment-methods';

export const useAddContractPenalty = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      bookingId,
      type,
      attemptDepositCharge,
    }: {
      bookingId: string;
      type: ContractPenaltyType;
      attemptDepositCharge?: boolean;
    }) => contractPenaltiesService.addContractPenalty(bookingId, { type, attemptDepositCharge }),
    onMutate: () => ({
      successMessage: 'Contract penalty added',
      invalidateQueryKeys: null,
    }),
    onSuccess: (result, variables, onMutateResult, context) => {
      queryClient.getMutationDefaults([])?.onSuccess?.(result, variables, onMutateResult, context);

      void queryClient.invalidateQueries({ queryKey: [BOOKINGS_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [INVOICES_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [LEDGER_ENTRIES_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [PAYMENTS_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [PAYMENT_ALLOCATIONS_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [NETTING_ELIGIBILITY_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [DAMAGES_QUERY_KEY] });
      void queryClient.invalidateQueries({
        queryKey: [STORED_PAYMENT_METHODS_QUERY_KEY, variables.bookingId],
      });
    },
  });
};
